module.exports = __webpack_public_path__ + "img/10.e5bccdd1.jpg";